/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.human-resources.hr-administrators'},
});

const HrAdministratorsItem = () => (
  <RouteLinkItem
    route="midas/settings/human-resources/hr-administrators"
    title={messages.title}
  />
);

export default HrAdministratorsItem;
